import { useMutation } from '@apollo/client';
import * as React from 'react';
import gql from 'graphql-tag';
import { GoogleAdsRequestTypeGq } from '../../models/GoogleAdsRequestTypeGq';

export default function useCreateGoogleAdsRequestGq() {
  const [mutation, mutationResult] = useMutation<ResponseGq, GqVariables>(gqTag);

  return React.useCallback(
    (command: CommandGq) =>
      mutation({ variables: { command } }).then(
        (result) => result.data.projects.createGoogleAdsRequest.requestId
      ),
    []
  );
}

const gqTag = gql`
  mutation CreateGoogleAdsRequest($command: CreateGoogleAdsRequestCommand!) {
    projects {
      createGoogleAdsRequest(command: $command) {
        requestId
      }
    }
  }
`;
interface ResponseGq {
  projects: {
    createGoogleAdsRequest: {
      requestId: number;
    };
  };
}

interface GqVariables {
  command: CommandGq;
}

export interface GoogleAdsRequestTagInputGq {
  tagGroupId?: number;
  tagGroupName?: string;
  tagId?: number;
  tagName?: string;
  useSeedKeywords?: boolean;
}

export interface CommandGq {
  projectId: number;
  type: GoogleAdsRequestTypeGq;
  name: string;
  seeds: string[];
  languageId?: number;
  languageName?: string;
  locationId?: number;
  locationName?: string;
  minSearchVolume: number;
  suggestionsWord?: boolean;
  suggestionsAlphabeticals?: boolean;
  suggestionsNumbers?: boolean;
  suggestionsQuestions?: boolean;
  suggestionsComparisons?: boolean;
  suggestionsPrepositions?: boolean;
  includeRankData?: boolean;
  includeTagKeywords?: boolean;
  tagKeywords?: GoogleAdsRequestTagInputGq;
}
